module.exports = __webpack_public_path__ + "static/media/bndvSites-alpha.b5cf4cd8.png";